// ## App
//
// Common variables/constants.

exports.VERSION = '2.3.6.1';

exports.FLASH = 'AUTHADOBEFLASH';
exports.HTML5 = 'AUTHADOBEHTML5';
exports.CLIENTLESS = 'AUTHADOBECLIENTLESS';

exports.REQUIRED_FLASH_VERSION = '10.1.53.64';

var isSecure = window.location.protocol === 'https:';
var cdnOrigin = isSecure ? 'https://s.cdn.turner.com' : 'http://z.cdn.turner.com';
exports.CDN_ORIGIN = cdnOrigin;

exports.CVP_CONFIG_ROOT = cdnOrigin + '/xslo/cvp/config';

var CONFIG_ENV_PREPROD = 'preprod';
var CONFIG_ENV_PROD = 'prod';
exports.CONFIG_ENV_PREPROD = CONFIG_ENV_PREPROD;
exports.CONFIG_ENV_PROD = CONFIG_ENV_PROD;
exports.configEnvOptions = [ CONFIG_ENV_PREPROD, CONFIG_ENV_PROD ];

exports.VENDOR_ENV_STAGING = 'staging';
exports.VENDOR_ENV_PROD = 'prod';
exports.ADOBE_ENTITLEMENT_STAGING_HOST = 'entitlement.auth-staging.adobe.com';
exports.ADOBE_ENTITLEMENT_PRODUCTION_HOST = 'entitlement.auth.adobe.com';
exports.ADOBE_API_STAGING_HOST = 'api.auth-staging.adobe.com';
exports.ADOBE_API_PRODUCTION_HOST = 'api.auth.adobe.com';
exports.getOriginForEnv = function (env) {
	switch (env) {
		case this.VENDOR_ENV_PROD: return location.protocol + '//' + this.ADOBE_ENTITLEMENT_PRODUCTION_HOST;
		case this.VENDOR_ENV_STAGING: return location.protocol + '//' + this.ADOBE_ENTITLEMENT_STAGING_HOST;
	}
};

exports.MVPD_ID_KEY = 'ID';
exports.DEFAULT_COUNTRY = 'US';
exports.UNKNOWN_COUNTRY = 'N/A';
exports.CONFIG_MULTIVALUE_DELIM = /\s*[|,]\s*/;

exports.DISAPPROVING_MVPDS = [
	'ATT',
	'Comcast_SSO'
];

exports.MIN_LOGOS_TO_DISPLAY = 1;
exports.MAX_LOGOS_TO_DISPLAY = 12;

exports.ADOBE_IFRAME_NAME = 'mvpdframe';  // Adobe expects this name for iframe/popup window
exports.ADOBE_WINDOW_NAME = 'mvpdwindow';  // Adobe expects this name for refreshless login window

exports.ErrorCategory = {
	LOG: 'LOG',
	INFO: 'INFO',
	WARN: 'WARN',
	AUTO: 'AUTO',
	USER: 'USER',
	BLOCKED: 'BLOCKED',
	severity: ['LOG', 'INFO', 'WARN', 'AUTO', 'USER', 'BLOCKED']
};

exports.Resolution = {

	RELOAD_PAGE:        '001',  // Reload page
	TRY_AGAIN_LATER:    '002',  // Try again later

	CLEAR_CACHE:        '011',  // Clear browser cache
	FIX_TIME:           '013',  // Correct device's date/time
	CHECK_NETWORK:      '014',  // Verify network settings and reload
	ALLOW_WRITE:        '015',  // Failure to write to storage

	LSO_STORAGE:        '021',  // Enable Flash Local Storage Objects (LSO) or increase LSO storage space
	LSO_WRITE:          '022',  // Unable to store; increase storage options or logout to clear storage

	LOG_IN_AGAIN:       '101',  // Log in again

	CONTENT_DISALLOWED: '201',  // Requested content is not included in your subscription
	POSSIBLE_FRAUD:     '202',  // Possible fraud attempt detected due to repeated denials
	MVPD_NOT_AVAILABLE: '203',  // MVPD is no longer available

	DRM_PROBLEM:        '300',  // Allow unsandboxed access, or Discontinue Incognito, or Reset DRM
	RESET_DRM:          '301',  // Reset DRM and reload page
	ENABLE_UNSANDBOX:   '302',  // Enable unsandboxed access and reload
	CEASE_INCOGNITO:    '303',  // Discontinue Incognito / Private mode
	ALLOW_IDENTIFIERS:  '304',  // Chrome32+: chrome://settings/content -> Allow identifiers for protected content

	UNKNOWN:            '000'

};

exports.Strings = {

	title: 'Login',

	// slate welcome
	welcomemessage: 'Get unlimited access to all your favorite content.<br/><br/>It\'s free through your participating TV Provider and available on your favorite devices.',
	welcomeloginbutton: 'Get Started',

	// slate remembered
	// rememberedmessage: [Dynamically-generated].
	rememberedcancelbutton: 'Not My TV Provider',
	rememberedokbutton: 'Continue to Log In',

	// slate pickbylogo
	viewallbutton: 'View All TV Providers',

	// slate findbyname
	viewtopbutton: 'View Top TV Providers',
	dontseebutton: 'I Don\'t See My TV Provider',

	// slate noprovider
	noprovidermessage: 'This service is only available through participating TV Providers.<br/><br/>Please check back soon to see if your TV Provider has been added.',
	noproviderokbutton: 'OK',

	// slate darkprovider
	// darkprovidermessage: [Dynamically-generated].
	darkproviderokbutton: 'OK',

	// slate signin
	signinmessage: 'Connecting...',
	signincancelbutton: 'Cancel',

	// slate error
	errormessage: 'There was a problem verifying your account with your TV Provider.<br/><br/>Please try again.',
	errorokbutton: 'OK',

	// slate success
	successmessage: 'Congratulations!<br><br>You\'re now ready to watch on mobile, tablet or the web.',
	watchnowbutton: 'Watch Now'

};
